export default "__VITE_ASSET__DuPp0NHr__"